<template>
	<div>
		<br>
		<section id="catalog" class="catalog" :class="[ catalog.data.length<=4 ?  'detailsif' : '' ] ">
			<div class="container" @click="closeModal">
				<!--					<h2><span class="lr"  v-if="total">-->
				<!--&lt;!&ndash;                        @if (isset($cname)) {{$cname}}&ndash;&gt;-->
				<!--&lt;!&ndash;                        @else Каталог продукции&ndash;&gt;-->
				<!--&lt;!&ndash;                        @endif&ndash;&gt;-->
				<!--						{{ total }}-->
				<!--                    </span></h2>-->
				<ul>
					<li v-for="cat in categories" @click="id=cat.id;current_page=1;getResults()">
						<h4 :class="[parseInt(id)===cat.id ? 'selectClass' :'' ]">
							{{ cat.name }}
						</h4>
					</li>
				</ul>
				<br>
				<div class="input-container">
					<input
									type="text"
									v-model="search"
									placeholder="Поиск..."
									@input="getResults()"
					/>
					<div
									class="clear-icon"
									v-if="search"
									@click="search='';getResults()"
									title="Очистить"
					></div>
				</div>
				<br><br>
				<div class="row central">
					<div class="col-md-3 col-lg-3 col-sm-12  " v-if="catalog.data && catalog.data.length>0" v-for="(item,key) in catalog.data">
						<div class="color item cat" @click="$router.push({name: 'details', params: { id: item.id}})">
							<span v-if="item.photo" class="nom">
								   <img :src="item.photo" alt="Product Image" class="product-image" ref="image"/>
							</span>
							<span v-else>
										<img src="/image/products/default.jpg" alt="item"><br>
								</span>
							<div class="text-h3">
								<br>
								<h3>{{ item.name }}</h3>
								<br>
							</div>
							<div class="row">
								<div class="form_radio_button centerall col-12" v-if="item.price.length>0">
									цена от {{ item.price[0].price }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<br><br>
				<div class="card-footer">
					<div class="row">
						<div class="col">
							<pagination :data="catalog" @pagination-change-page="getResults" :limit="2">
								<!--									<span slot="prev-nav">&lt; Назад</span>-->
								<!--									<span slot="next-nav">Вперед &gt;</span>-->
							</pagination>
						</div>
						<div class="col">
							<select class="form-control" v-model="pagination" @change="getResults">
								<option value="4">5</option>
								<option value="12">10</option>
								<option value="44">50</option>
								<option value="96">100</option>
								<option value="all">Все</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<br>
		</section>
		<div class="trash_button cart" id="trash_button" @click="$refs.modal.openModal()">
			<span id="count">{{ this.getCookie('count') }}</span>
		</div>
		<right-cart-widget v-bind:id="'cart-modal'" ref="modal"/>
	</div>
</template>

<script>
export default {
	props: [
		'id',
	],
	data() {
		return {
			editmode    : false,
			picked      : false,
			sort        : {
				id   : 'ASC',
				email: 'ASC',
				role : 'ASC',
			},
			search      : '',
			categories  : {},
			price_view  : [],
			ids         : 1,
			i           : 1,
			pagination  : 12,
			res         : [],
			catalog     : {},
			current_page: 1,
			sortable    : '',
			total       : 0,
			date_title  : new Date().toLocaleDateString(),
			token       : document.head.querySelector('meta[name="csrf-token"]'),
			urls        : {
				getdata : "/api/client/catalog?page=",
				category: "/api/client/category",
			}
		}
	},
	methods: {
		handleClick(item, price, key) {
			// this.radio_price(price, key);
			// item.cost = price.price;
			// item.text = price.price;
		},
		setFirstButtonActive() {
			this.items.forEach(item => {
				if (item.price.length > 0) {
					const firstPrice = item.price[0];
					item.text = firstPrice.price; // Устанавливаем текст на значение первой кнопки
					this.radio_price(firstPrice, 0); // Вызов метода radio_price для первой кнопки
					item.cost = firstPrice.price; // Устанавливаем стоимость
				}
			})
		},
		closeModal() {
			this.$refs.modal.closeModal()
		},
		setCookie(id, value) {
			document.cookie = id + '=' + value + ';path=/';
		},
		getCookie(name) {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);

			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			}
			return null;
		},

		radio_price(data, key) {
			//console.log(data, key);
			this.catalog.data[key]['cid'] = data.id
			this.catalog.data[key]['price_view'] = data.price
			this.catalog.data[key]['weight'] = data.weight
			//console.log(this.catalog.data[key]);
		},
		fsort(name) {
			if (this.sort[name] == 'ASC') {
				this.sort[name] = 'DESC';
			} else {
				this.sort[name] = 'ASC'
			}
		},
		async getResults(page, sort) {
			this.fsort(sort);
			if (page == undefined) {
				page = this.current_page;
			} else {
				this.current_page = page;
			}
			axios.get(this.urls.getdata + page, {
				params : {
					id        : this.id,
					sort      : sort,
					sortable  : this.sortable,
					search    : this.search,
					pagination: this.pagination
				},
				headers: {
					"X-CSRF-TOKEN": this.token.content,
				}
			})
							.then(({data}) => (
											this.total = data.total,
															this.catalog = data,
															this.sortable = data['message']
							))
							.catch((errors) => {
								this.toastError(errors.response.data.errors);
							});

		},
		// getResults(){
		// 	axios.get(this.urls.getdata + this.id ).then(({ data }) => (this.catalog = data.data));
		// },
		getCategory() {
			axios.get(this.urls.category).then(({data}) => (this.categories = data.data));
		},
	},
	created() {
		this.getCategory();
		this.getResults();
	}
}
</script>
<style scoped>
.cat {
	//margin: 1em;
}

.selectClass {
	background-color: #828080;
	color: #ffffff;
	height: 2em;
	display: flex; /* Используем flexbox для центрирования */
	align-items: center; /* Вертикальное центрирование */
	padding: 0 10px
}

li {
	list-style-type: none;
	/* Убираем маркеры */
}

li:hover {
	font-family: "Open Sans";
	background-color: #828080;
	color: #ffffff;
	text-decoration: none;
	user-select: none;
}

.buy {

}

.detailsif {
	height: 88vh;
}

ul {
	margin-left: 0;
	padding-left: 0;
}
</style>